import moment from 'moment';

function isStringOrNumber(value) {
  return typeof value === 'number' || typeof value === 'string';
}

export default function getAnneeSemaine(annee, semaine) {
  if (!isStringOrNumber(annee) || !isStringOrNumber(semaine)) return null;
  return `${annee.toString()}${semaine.toString().padStart(2, '0')}`;
}

export function getDateByJourAnneeSemaine(jourDepart, annee, semaine) {
  if (annee === undefined) return moment();
  try {
    return moment().day(jourDepart + 1)
      .isoWeekYear(annee)
      .isoWeek(semaine);
  } catch (error) {
    return moment();
  }
}



// WEBPACK FOOTER //
// ./src/services/general/getAnneeSemaine.js